'use strict';

angular.module('docketbook').
  service('addressBookService', function (jobService, accessControl, $http, $stateParams, $cookies, $q, Restangular, geolocation) {

    this.getConnections = function (params, successCb, failureCb) {
      var organisation = accessControl.currentOrg()
      if (params == null) {
        params = {};
      }

      Restangular.all('organisations').one(organisation.id).all('connections').getList(params).then(successCb, failureCb)
    }

    this.getFilteredConnections = function (params, successCb, failureCb) {
      var organisation = accessControl.currentOrg()
      Restangular.all('organisations').one(organisation.id).all('connections').customPOST(params).then(successCb, failureCb)
    }

    this.getInvitations = function (params, successCb, failureCb) {
      if (params == null) {
        params = {};
      }

      var organisation = accessControl.currentOrg()
      Restangular.all('organisations').one(organisation.id).all('connections').all('invitations').getList(params).then(successCb, failureCb)
    }

    this.getFilteredInvitations = function (params, successCb, failureCb) {
      var organisation = accessControl.currentOrg()
      Restangular.all('organisations').one(organisation.id).all('connections').all('invitations').customPOST(params).then(successCb, failureCb)
    }

    this.saveInvitation = function (invitation, successCb, failureCb) {
      var organisation = accessControl.currentOrg()
      Restangular.all('organisations').one(organisation.id).all('connections').all('invitations').one(invitation.id).customPUT({ status: invitation.status }).then(successCb, failureCb)
    }

    this.createConnections = function (connections, successCb, failureCb) {
      var organisation = accessControl.currentOrg()
      Restangular.all('organisations').one(organisation.id).all('connections').one('invite').one('bulk').customPOST(connections).then(successCb, failureCb);
    }

    this.cancelInvitation = function (invitation, successCb, failureCb) {
      var organisation = accessControl.currentOrg()
      Restangular.all('organisations').one(organisation.id).all('connections').all('invitations').one(invitation.id).customDELETE('').then(successCb, failureCb);
    }

    this.removeConnection = function (connection, successCb, failureCb) {
      var organisation = accessControl.currentOrg()
      Restangular.all('organisations').one(organisation.id).all('connections').one(connection.id).customDELETE('').then(successCb, failureCb);
    }



    this.getAddressBookTags = function (params, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseAddressBook = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('tags');
      if (params == null) {
        params = {};
      }
      baseAddressBook.getList(params).then(successCb, failureCb);
    }

    this.saveAddressBookTag = function (tag, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseAddressBook = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('tags');
      if (!tag.id) {
        baseAddressBook.customPOST(tag).then(successCb, failureCb)
      } else {
        baseAddressBook.one(tag.id).customPUT(tag).then(successCb, failureCb)
      }
    }

    this.deleteAddressBookTag = function (tag, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseAddressBook = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('tags').one(tag.id);
      baseAddressBook.customDELETE("").then(successCb, failureCb)
    }

    this.getAddressBook = function (params, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseAddressBook = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('addressbook');
      if (params == null) {
        params = {};
      }
      baseAddressBook.getList(params).then(successCb, failureCb);
    }

    this.getAddressBookContact = function (addressBookId, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseAddressBook = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('addressbook');
      baseAddressBook.one(addressBookId).get().then(successCb, failureCb);
    }

    this.getAddressBookForUnit = function (params, successCb, failureCb) {
      var organisation = accessControl.currentOrg().id;
      var organisationGroup = accessControl.currentOrgGroup().id;

      var baseAddressBook = Restangular.all('organisations').one(organisation).all('groups').one(organisationGroup).all('addressbook');
      if (params == null) {
        params = {};
      }
      baseAddressBook.getList(params).then(successCb, failureCb);
    }

    var saveContact = function (contact, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseAddressBook = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('addressbook');

      if (contact.id == null) {
        baseAddressBook.customPOST(contact).then(successCb, failureCb);
      } else {
        baseAddressBook.one(contact.id).customPUT(contact).then(successCb, failureCb);
      }
    }

    this.saveContact = saveContact;

    this.saveContactForUnit = function (org, orgUnit, contact, successCb, failureCb) {
      var organisation = org;
      var organisationGroup = orgUnit;
      if (organisation == null || organisationGroup == null) {
        organisation = accessControl.currentOrg();
        organisation = organisation.id;
        organisationGroup = accessControl.currentOrgGroup();
        organisationGroup = organisationGroup.id;
      }
      var baseAddressBook = Restangular.all('organisations').one(organisation).all('groups').one(organisationGroup).all('addressbook');

      if (contact.id == null) {
        baseAddressBook.customPOST(contact).then(successCb, failureCb);
      } else {
        baseAddressBook.one(contact.id).customPUT(contact).then(successCb, failureCb);
      }
    }

    var deleteContact = function (contactId, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseAddressBook = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('addressbook');

      if (contactId.id != null) {
        contactId = contactId.id;
      }

      baseAddressBook.one(contactId).remove().then(successCb, failureCb);
    }

    this.deleteContact = deleteContact;

    this.deleteBulkContacts = function (contacts, successCb) {
      var failures = {};
      deleteContacts(contacts, 0, failures, successCb);
    }

    var deleteContacts = function (contacts, index, failures, successCb) {
      if (index >= contacts.length) {
        successCb(failures);
        return;
      }

      deleteContact(contacts[index], function () {
        deleteContacts(contacts, index + 1, failures, successCb);
      }, function (err) {
        failures.push(contacts[index]);
        deleteContacts(contacts, index + 1, failures, successCb);
      });
    }

    /**** Bulk Import Contacts ****/

    this.bulkImportContacts = function (contactsList, successCb, failureCb) {
      var failures = [];
      importContacts(contactsList, 0, failures, successCb);
    }

    var importContacts = function (contacts, index, failures, successCb) {
      if (index >= contacts.length) {
        successCb(failures);
        return;
      }

      saveContact(contacts[index], function () {
        importContacts(contacts, index + 1, failures, successCb);
      }, function (err) {
        console.error('could not save contact', err)
        failures.push(contacts[index]);
        importContacts(contacts, index + 1, failures, successCb);
      });
    }

    /**** Contact Shares ****/
    this.getContactShares = function (params, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseContactShares = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('contact_share');
      if (params == null) {
        params = {};
      }
      baseContactShares.getList(params).then(successCb, failureCb);
    }

    this.getUserContactShares = function (params, successCb, failureCb) {
      var baseContactShares = Restangular.all('contact_share');
      if (params == null) {
        params = {};
      }
      baseContactShares.getList(params).then(successCb, failureCb);
    }

    var saveContactShare = function (share, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseContactShares = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('contact_share');

      if (share.id == null) {
        baseContactShares.customPOST(share).then(successCb, failureCb);
      } else {
        baseContactShares.one(share.id).customPUT(share).then(successCb, failureCb);
      }
    }

    this.saveContactShare = saveContactShare;

    this.saveBulkContactShares = function (emails, share, successCb) {
      var failures = [];
      saveBulkContactShares(0, emails, share, failures, successCb);
    }

    var saveBulkContactShares = function (index, emails, share, failures, successCb) {
      if (index >= emails.length) {
        successCb(failures);
        return;
      }

      var shareToSave = share;
      share.recipient = emails[index];
      saveContactShare(share, function () {
        saveBulkContactShares(index + 1, emails, share, failures, successCb);
      }, function (err) {
        failures.push(emails[index]);
        saveBulkContactShares(index + 1, emails, share, failures, successCb);
      });
    }

    var deleteContactShare = function (shareId, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseContactShares = Restangular.all('contact_share');

      if (organisation != null && organisationGroup != null) {
        baseContactShares = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('contact_share');
      }

      if (shareId.id != null) {
        shareId = shareId.id;
      }

      baseContactShares.one(shareId).remove().then(successCb, failureCb);
    }

    this.deleteContactShare = deleteContactShare;

    this.deleteBulkContactShares = function (shares, successCb) {
      var failures = [];
      deleteContactShares(0, shares, failures, successCb);
    }

    var deleteContactShares = function (index, shares, failures, successCb) {
      if (index >= shares.length) {
        successCb(failures);
        return;
      }

      deleteContactShare(shares[index], function () {
        deleteContactShares(index + 1, shares, failures, successCb);
      }, function (err) {
        failures.push(shares[index]);
        deleteContactShare(index + 1, shares, failures, successCb);
      });
    }
  });



// WEBPACK FOOTER //
// ./src/services/addressBookService.js